__turbopack_context__.v({
  "container": "ZDrz2W_container",
  "content": "ZDrz2W_content",
});
